/**
 * MediaType constants for http requests
 */
export abstract class MediaType {
  public static readonly zipMediaType = 'application/zip';
  public static readonly jsonUtf8MediaType = 'application/json; charset=utf-8';
  public static readonly xmlMediaType = 'application/xml';
  public static readonly textPlainMediaType = 'text/plain';
  public static readonly csvUtf8MediaType = 'text/comma-separated-values;charset=UTF-8';
  public static readonly textPlainUtf8MediaType = 'text/plain;charset=UTF-8';
  public static readonly textCommaSeparatedUtf8MediaType =
    'text/comma-separated-values;charset=UTF-8';
  public static readonly textCsvMediaType = 'text/csv';
}
